import { render } from "./room-settings.vue?vue&type=template&id=1ad55cb6"
import script from "./room-settings.vue?vue&type=script&lang=js"
export * from "./room-settings.vue?vue&type=script&lang=js"

import "./room-settings.vue?vue&type=style&index=0&id=1ad55cb6&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__